import { GetCurrentUserQuery } from "../GetCurrentUser.generated";

export default function showPPTOS(me: GetCurrentUserQuery["me"]) {
  return me?.__typename !== "Inmate" || me.facility.system.showPPTOS;
}
